/* @flow */
import { FETCH_MAINTENANCE_DIAGNOSTICS_LIST, FETCH_MAINTENANCE_DIAGNOSTICS_LIST_SUCCESS, FETCH_MAINTENANCE_DIAGNOSTICS_LIST_ERROR, RESET_MAINTENANCE_DIAGNOSTICS_LIST } from './constants.diagnosticList';

const initialState = {
    diagnostics: [],
    isUpdating: false,
    totalAlerts: 0,
};

type stateType = {
    diagnostics: Array<Object>,
    isUpdating: boolean,
    totalAlerts: number,

}
type actionType = {
    type: string,
    payload :{
        records:{},
        totalRecords: number
    }
}

export default (state:stateType = initialState, action:actionType) => {
    switch (action.type) {
    case FETCH_MAINTENANCE_DIAGNOSTICS_LIST:
        return {
            ...state,
            isUpdating: true,
        };
    case RESET_MAINTENANCE_DIAGNOSTICS_LIST:
        return {
            ...state,
            isUpdating: false,
            records: [],
            totalRecords: 0,
        };
    case FETCH_MAINTENANCE_DIAGNOSTICS_LIST_SUCCESS:
        return {
            ...state,
            isUpdating: false,
            records: action.payload.records,
            totalRecords: action.payload.totalRecords,
        };
    case FETCH_MAINTENANCE_DIAGNOSTICS_LIST_ERROR:
        return {
            ...state,
            isUpdating: false,
        };
    default:
        return state;
    }
};
